function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import pathOr from 'ramda/src/pathOr';
import uniq from 'ramda/src/uniq';
import pluck from 'ramda/src/pluck';
import { getUiNotificationService } from 'invision-core/src/components/injectables/injector.helper';
import { RouteParams } from 'invision-core/src/components/router/router.selectors';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import { ThunkHelper } from 'invision-core';
import CustomerCareKeys from '../../locales/keys';
import createWizardActions from '../helpers/offer.ordering.wizard.action.helper';
import { ADD_WIZARD_PREFIX } from '../constants/wizard.constants';
import { RESUME_ORDER_INSUFFICIENT_ACCESS_WARNING_CODE } from '../../customercare.constants';
import { addSubscriberHeaders, calculateOfferingOrderQuotePromise, clearOfferingOrderQuote, clearQuote, getContractId, retrieveAttributesPromise, retrieveOfferingContextPromise, setExternalContractId, setPurchaseOrderNumber, setSelectedInventoryStores, setSelectedOfferName, submitOrderPromise, updateMultiOfferShoppingCartPromise } from './offering.order.actions';
import { retrieveContractPromise, setSelectedContract } from './contract.details.actions';
// TODO: CustomerOrder: We should not be importing a selector from other wizards, if so it should be shared.
import { EditCustomerInfoSelector } from '../selectors/new.connect.wizard.selectors';
import { ShoppingCartSelector } from '../selectors/customer.selectors';
import { EditedMultiOfferShoppingCartSelector } from '../selectors/add.offer.wizard.selectors';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
var wizardActions = createWizardActions(ADD_WIZARD_PREFIX);
export var BEGIN_ADD_OFFER_ORDER = 'BEGIN_ADD_OFFER_ORDER';
export var CANCEL_ORDER = wizardActions.CANCEL_WIZARD;
export var GO_TO_NEXT_STEP = wizardActions.GO_TO_NEXT_STEP;
export var GO_TO_PREVIOUS_STEP = wizardActions.GO_TO_PREVIOUS_STEP;
export var GO_TO_STEP = wizardActions.GO_TO_STEP;
export var INITIALIZE_AS_MULTI_OFFER_WIZARD = 'INITIALIZE_AS_MULTI_OFFER_WIZARD';
export var MULTI_OFFER_SET_COMPLETED_STEPS = 'MULTI_OFFER_SET_COMPLETED_STEPS';
export var RESET_FOR_CONTINUE_SHOPPING = 'RESET_FOR_CONTINUE_SHOPPING';
export var RESET_MULTI_OFFERS = 'RESET_MULTI_OFFERS';
export var RESET_OFFER_ADDITIONAL_PROPERTIES = wizardActions.RESET_OFFER_ADDITIONAL_PROPERTIES;
export var RESET_PICKUP_ID = 'RESET_PICKUP_ID';
export var RESTORE_OPTION_DEFAULT_PRICING = wizardActions.RESTORE_OPTION_DEFAULT_PRICING;
export var RESUME_ORDER_SET_SELECTED_OFFER_ID = 'RESUME_ORDER_SET_SELECTED_OFFER_ID';
export var RETRIEVE_ADDRESSES = wizardActions.RETRIEVE_ADDRESSES;
export var SAVE_OPTION_PRICING = wizardActions.SAVE_OPTION_PRICING;
export var SEND_PORT_IN_OR_ITEM_RESERVATION = wizardActions.SEND_PORT_IN_OR_ITEM_RESERVATION;
export var SET_ATTRIBUTE_SEARCHING_INVENTORY = wizardActions.SET_ATTRIBUTE_SEARCHING_INVENTORY;
export var SET_CURRENT_STEP_IS_INVALID = wizardActions.SET_CURRENT_STEP_IS_INVALID;
export var SET_EDIT_ATTRIBUTE_GROUPS = wizardActions.SET_EDIT_ATTRIBUTE_GROUPS;
export var SET_EDIT_CART_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_CART_ADDITIONAL_PROPERTY;
export var SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_OFFER_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_OFFER_ADDITIONAL_PROPERTY;
export var SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_OPTION = wizardActions.SET_EDIT_OPTION;
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_ORDER_ADDITIONAL_PROPERTY;
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS = wizardActions.SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS;
export var SET_PAYMENT_INFO = wizardActions.SET_PAYMENT_INFO;
export var SET_REMOVE_OFFER_INSTANCE_ID = 'SET_REMOVE_OFFER_INSTANCE_ID';
export var SET_SELECTED_ADD_OFFER_TAB = wizardActions.SET_SELECTED_WIZARD_TAB;
export var SET_SELECTED_FACETS_EDIT_COPY = wizardActions.SET_SELECTED_FACETS_EDIT_COPY;
export var SET_SELECTED_OFFER = wizardActions.SET_SELECTED_OFFER;
export var SET_SELECTED_OFFER_EDIT_COPY = wizardActions.SET_SELECTED_OFFER_EDIT_COPY;
export var SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY = wizardActions.SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY;
export var SET_TRANSFER_FROM_SUBSCRIBER_ID = 'SET_TRANSFER_FROM_SUBSCRIBER_ID';
export var SET_TRANSFER_FROM_NAME = 'SET_TRANSFER_FROM_NAME';
export var UPDATE_BILL_CYCLE = wizardActions.UPDATE_BILL_CYCLE;
export var UPDATE_EDIT_BRI_PRICE = wizardActions.UPDATE_EDIT_BRI_PRICE;
export var UPDATE_INVENTORY_SELECTION = wizardActions.UPDATE_INVENTORY_SELECTION;
export var UPDATE_OFFER_ATTRIBUTE = wizardActions.UPDATE_OFFER_ATTRIBUTE;
export var UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL = wizardActions.UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL;
export var UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE = wizardActions.UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE;
export var UPDATE_PAYMENT_INFO = wizardActions.UPDATE_PAYMENT_INFO;
export var UPDATE_PORT_IN_REQUEST = wizardActions.UPDATE_PORT_IN_REQUEST;
export var UPDATE_SELECTED_SERVICE_FEATURES = wizardActions.UPDATE_SELECTED_SERVICE_FEATURES;
export var UPDATE_SHOPPING_CART = wizardActions.UPDATE_SHOPPING_CART;
export var multiOfferSetCompletedSteps = function multiOfferSetCompletedSteps() {
  return {
    type: MULTI_OFFER_SET_COMPLETED_STEPS
  };
};
export var beginAddOfferOrder = function beginAddOfferOrder(isMultiOffer) {
  return {
    type: BEGIN_ADD_OFFER_ORDER,
    payload: {
      isMultiOffer: isMultiOffer
    }
  };
};
export var resetForContinueShopping = function resetForContinueShopping() {
  return {
    type: RESET_FOR_CONTINUE_SHOPPING
  };
};
export var resetMultiOffers = function resetMultiOffers() {
  return {
    type: RESET_MULTI_OFFERS
  };
};
export var resetPickupId = function resetPickupId() {
  return {
    type: RESET_PICKUP_ID
  };
};
export var initializeAsMultiOfferWizard = function initializeAsMultiOfferWizard(payload) {
  return {
    type: INITIALIZE_AS_MULTI_OFFER_WIZARD,
    payload: payload
  };
};
export var setTransferFromName = function setTransferFromName(payload) {
  return {
    type: SET_TRANSFER_FROM_NAME,
    payload: payload
  };
};
export var setTransferFromSubscriberId = function setTransferFromSubscriberId(payload) {
  return {
    type: SET_TRANSFER_FROM_SUBSCRIBER_ID,
    payload: payload
  };
};
var resumeOrderSetSelectOffer = function resumeOrderSetSelectOffer(selectedOfferId) {
  return {
    type: RESUME_ORDER_SET_SELECTED_OFFER_ID,
    payload: selectedOfferId
  };
};
export var setRemoveOfferInstanceId = function setRemoveOfferInstanceId(removeOfferInstanceId) {
  return {
    type: SET_REMOVE_OFFER_INSTANCE_ID,
    payload: removeOfferInstanceId
  };
};
var setSelectedOffer = wizardActions.setSelectedOffer;
export var cancelOrder = wizardActions.cancelWizard;
export var clearQuoteAndSetSelectedOffer = wizardActions.clearQuoteAndSetSelectedOffer;
export var fetchAddresses = wizardActions.fetchAddresses;
export var fetchAttributes = wizardActions.fetchAttributes;
export var fetchWallet = wizardActions.fetchWallet;
export var goToNextStep = wizardActions.goToNextStep;
export var goToPreviousStep = wizardActions.goToPreviousStep;
export var goToStep = wizardActions.goToStep;
export var resetOfferAdditionalProperties = wizardActions.resetOfferAdditionalProperties;
export var restoreOptionDefaultPricing = wizardActions.restoreOptionDefaultPricing;
export var saveBulkPricing = wizardActions.saveBulkPricing;
export var searchAttributeInventory = wizardActions.searchAttributeInventory;
export var sendPortInOrItemReservation = wizardActions.sendPortInOrItemReservation;
export var setCurrentStepIsInvalid = wizardActions.setCurrentStepIsInvalid;
export var setEditAttributeGroups = wizardActions.setEditAttributeGroups;
export var setEditCartAdditionalProperty = wizardActions.setEditCartAdditionalProperty;
export var setEditCartAdditionalPropertyOnChange = wizardActions.setEditCartAdditionalPropertyOnChange;
export var setEditOfferAdditionalProperty = wizardActions.setEditOfferAdditionalProperty;
export var setEditOfferAdditionalPropertyOnChange = wizardActions.setEditOfferAdditionalPropertyOnChange;
export var setEditOption = wizardActions.setEditOption;
export var setEditOrderAdditionalProperty = wizardActions.setEditOrderAdditionalProperty;
export var setEditOrderAdditionalPropertyOnChange = wizardActions.setEditOrderAdditionalPropertyOnChange;
export var setEditPhysicalAttributeGroups = wizardActions.setEditPhysicalAttributeGroups;
export var setPaymentInfo = wizardActions.setPaymentInfo;
export var setSelectedFacetsEditCopy = wizardActions.setSelectedFacetsEditCopy;
export var setSelectedOfferEditCopy = wizardActions.setSelectedOfferEditCopy;
export var setSelectedOfferingChargeTypesEditCopy = wizardActions.setSelectedOfferingChargeTypesEditCopy;
export var setSelectedTab = wizardActions.setSelectedTab;
export var updateAttribute = wizardActions.updateAttribute;
export var updateBillCycle = wizardActions.updateBillCycle;
export var updateCart = wizardActions.updateCart;
export var updateEditOptionPrice = wizardActions.updateEditOptionPrice;
export var updateInventorySelection = wizardActions.updateInventorySelection;
export var updateOfferPhysicalInventoryMakeAndModel = wizardActions.updateOfferPhysicalInventoryMakeAndModel;
export var updateOfferPhysicalInventoryTypeAttribute = wizardActions.updateOfferPhysicalInventoryTypeAttribute;
export var updatePaymentInfo = wizardActions.updatePaymentInfo;
export var updatePortInRequest = wizardActions.updatePortInRequest;
export var updateSelectedServiceFeatures = wizardActions.updateSelectedServiceFeatures;
export var updateShoppingCart = wizardActions.updateShoppingCart;
export var RESUME_ORDER = {
  BEGIN: 'RESUME_ORDER_BEGIN',
  SUCCESS: 'RESUME_ORDER_SUCCESS',
  FAILURE: 'RESUME_ORDER_FAILURE'
};
var RESUME_ORDER_EVENTS = [RESUME_ORDER.BEGIN, RESUME_ORDER.SUCCESS, RESUME_ORDER.FAILURE];
export var RESUME_ORDER_ATTRIBUTES = {
  BEGIN: 'RESUME_ORDER_ATTRIBUTES_BEGIN',
  SUCCESS: 'RESUME_ORDER_ATTRIBUTES_SUCCESS',
  FAILURE: 'RESUME_ORDER_ATTRIBUTES_FAILURE'
};
var RESUME_ORDER_ATTRIBUTES_EVENTS = [RESUME_ORDER_ATTRIBUTES.BEGIN, RESUME_ORDER_ATTRIBUTES.SUCCESS, RESUME_ORDER_ATTRIBUTES.FAILURE];
export var RESUME_STORE_ORDER = {
  BEGIN: 'RESUME_STORE_ORDER_BEGIN',
  SUCCESS: 'RESUME_STORE_ORDER_SUCCESS',
  FAILURE: 'RESUME_STORE_ORDER_FAILURE'
};
var RESUME_STORE_ORDER_EVENTS = [RESUME_STORE_ORDER.BEGIN, RESUME_STORE_ORDER.SUCCESS, RESUME_STORE_ORDER.FAILURE];
export var RETRIEVE_SHOPPING_CART_OFFERINGS = {
  BEGIN: 'RETRIEVE_SHOPPING_CART_OFFERINGS_BEGIN',
  SUCCESS: 'RETRIEVE_SHOPPING_CART_OFFERINGS_SUCCESS',
  FAILURE: 'RETRIEVE_SHOPPING_CART_OFFERINGS_FAILURE'
};
var RETRIEVE_SHOPPING_CART_OFFERINGS_EVENTS = [RETRIEVE_SHOPPING_CART_OFFERINGS.BEGIN, RETRIEVE_SHOPPING_CART_OFFERINGS.SUCCESS, RETRIEVE_SHOPPING_CART_OFFERINGS.FAILURE];
export var resumeOrderPromise = function resumeOrderPromise(dispatch, customerId, contractId, isConvergentBiller, offeringInstanceId, pickupId) {
  var data = {
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    ContractId: contractId,
    Offerings: offeringInstanceId ? [{
      OfferingInstanceId: offeringInstanceId
    }] : undefined,
    PickupId: pickupId || undefined,
    RetrievePhysicalInventoryDecisions: false,
    RetrieveServiceAttributes: false,
    UseSavedShoppingCart: true
  };
  return ThunkHelper(dispatch, RESUME_ORDER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
var resumeOrderHelper = function resumeOrderHelper(dispatch, customer, resumeOrderResponse, isConvergentBiller, shouldCalculateTaxes, paymentInstrument, offeringInstanceId, isMultiOfferEditing, pickupId) {
  if (resumeOrderResponse.ShoppingCart.Items[0].PurchaseOrderNumber) {
    dispatch(setPurchaseOrderNumber(resumeOrderResponse.ShoppingCart.Items[0].PurchaseOrderNumber));
  }
  if (resumeOrderResponse.ShoppingCart.Items[0].ExternalContractId) {
    dispatch(setExternalContractId(resumeOrderResponse.ShoppingCart.Items[0].ExternalContractId));
  }
  dispatch(resumeOrderSetSelectOffer(resumeOrderResponse.Context.OfferingIds[0]));
  if (resumeOrderResponse.Context.Decisions.length > 0) {
    dispatch(setSelectedOfferName(resumeOrderResponse.ShoppingCart.Items[0].OrderedOfferingName));
    if (isMultiOfferEditing) {
      // Having to call RoC a 2nd time in order to pre-fill the attributes on the following step if you were to
      // increment or decrement the decisions.
      resumeOrderAttributesPromise(dispatch, customer.Id, isConvergentBiller, offeringInstanceId, pickupId).then(function () {
        dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.DECISIONS), true);
      }).catch(function (error) {
        //Should be handled in the component but these actions are already deeply chained.
        getUiNotificationService().transientError(error.translatedMessage);
      });
    } else {
      dispatch(goToNextStep());
    }
  } else {
    resumeOrderAttributesPromise(dispatch, customer.Id, isConvergentBiller, offeringInstanceId, pickupId).then(function (response) {
      if (response.Context.ValueDecisions.length > 0 || response.Context.PhysicalInventoryDecisions.length > 0) {
        dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.ATTRIBUTES), true);
      } else {
        calculateAddOfferOrderQuotePromise(dispatch, customer, response.ShoppingCart, undefined, customer.Language, shouldCalculateTaxes, paymentInstrument, isConvergentBiller).then(function () {
          dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT), true);
        }).catch(function (error) {
          getUiNotificationService().transientError(error.translatedMessage);
        });
      }
    });
  }
};
export var resumeOrder = function resumeOrder(customer, errorCallback, isConvergentBiller) {
  var shouldCalculateTaxes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var paymentInstrument = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var offeringInstanceId = arguments.length > 5 ? arguments[5] : undefined;
  var isMultiOfferEditing = arguments.length > 6 ? arguments[6] : undefined;
  var pickupId = arguments.length > 7 ? arguments[7] : undefined;
  return function (dispatch, getState) {
    var shoppingCart = ShoppingCartSelector(getState());
    var contractId = shoppingCart && shoppingCart.Items && shoppingCart.Items.length && shoppingCart.Items[0].OrderContractId ? shoppingCart.Items[0].OrderContractId : null;
    return resumeOrderPromise(dispatch, customer.Id, contractId, isConvergentBiller, offeringInstanceId, pickupId).then(function (response) {
      if (contractId) {
        return retrieveContractPromise(dispatch, contractId).then(function (result) {
          if (result.OrderContract.IsActive) {
            dispatch(setSelectedContract(result.OrderContract));
            resumeOrderHelper(dispatch, customer, response, isConvergentBiller, shouldCalculateTaxes, paymentInstrument, offeringInstanceId, isMultiOfferEditing, pickupId);
          } else {
            dispatch(beginAddOfferOrder());
            errorCallback();
          }
        });
      } else {
        resumeOrderHelper(dispatch, customer, response, isConvergentBiller, shouldCalculateTaxes, paymentInstrument, offeringInstanceId, isMultiOfferEditing, pickupId);
      }
    }).catch(function () {
      getUiNotificationService().transientError(i18n.translate(CustomerCareKeys.RESUME_ORDER_FAILURE));
    });
  };
};
export var resumeOrderAttributesPromise = function resumeOrderAttributesPromise(dispatch, customerId, isConvergentBiller, offeringInstanceId, pickupId) {
  var completedDecisions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var offeringId = arguments.length > 6 ? arguments[6] : undefined;
  var data = {
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    CompletedDecisionsList: completedDecisions,
    ContractId: getContractId(),
    Offerings: offeringInstanceId ? [{
      OfferingId: offeringId,
      OfferingInstanceId: offeringInstanceId
    }] : undefined,
    RetrievePhysicalInventoryDecisions: true,
    RetrieveDeliveryDecisions: true,
    RetrieveServiceAttributes: true,
    UseSavedShoppingCart: true,
    PickupId: pickupId || undefined
  };
  return ThunkHelper(dispatch, RESUME_ORDER_ATTRIBUTES_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
export var resumeOrderAttributes = function resumeOrderAttributes(customerId, isConvergentBiller) {
  var skipStepLogic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var offeringInstanceId = arguments.length > 3 ? arguments[3] : undefined;
  var pickupId = arguments.length > 4 ? arguments[4] : undefined;
  var completedDecisions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var offeringId = arguments.length > 6 ? arguments[6] : undefined;
  return function (dispatch) {
    return resumeOrderAttributesPromise(dispatch, customerId, isConvergentBiller, offeringInstanceId, pickupId, completedDecisions, offeringId).then(function (response) {
      if (!skipStepLogic) {
        if (response.Context.ValueDecisions.length > 0 || response.Context.PhysicalInventoryDecisions.length > 0) {
          dispatch(goToNextStep());
        } else {
          dispatch(goToStep([CustomerCareKeys.WIZARD.STEPS.CHECKOUT, true]));
        }
      }
    }).catch(function () {
      getUiNotificationService().error(i18n.translate(CustomerCareKeys.RESUME_ORDER_FAILURE));
    });
  };
};
var resumeStoreOrderPromise = function resumeStoreOrderPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RESUME_STORE_ORDER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/ResumeStoreOrder',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      RetrievePhysicalInventoryDecisions: false,
      RetrieveServiceAttributes: false
    }
  });
};
export var resumeStoreOrder = function resumeStoreOrder(customerInfo, isResumeChangeOffer) {
  var bypassQuote = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch) {
    return resumeStoreOrderPromise(dispatch, customerInfo.Id).then(function (response) {
      if (isResumeChangeOffer || response.Warnings && !!response.Warnings.find(function (warning) {
        return warning.Code === RESUME_ORDER_INSUFFICIENT_ACCESS_WARNING_CODE;
      })) {
        return response;
      } else {
        var pickupId = pathOr(null, ['ShoppingCart', 'SubscriberPhysicalInventoryPickupDetail', 'Id'], response);
        if (pickupId) {
          var physicalInventoryItemWithStore = response.ShoppingCart.Items.find(function (item) {
            return pathOr(null, ['PhysicalInventories', 0, 'StoreId'], item);
          });
          dispatch(setSelectedInventoryStores([physicalInventoryItemWithStore.PhysicalInventories[0].StoreId.toString()]));
        }

        // Cancelling a change offer requires that it puts the offer into a multi offer flow, be it single offer or multi offer
        dispatch(setMultiOfferShoppingCart(response.ShoppingCart));
        return calculateOfferingOrderQuotePromise(dispatch, customerInfo, response.ShoppingCart, undefined, undefined, undefined, undefined, bypassQuote).catch(function (error) {
          return getUiNotificationService().transientError(error.translatedMessage);
        }).finally(function () {
          dispatch(multiOfferSetCompletedSteps());
          dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT));
        });
      }
    });
  };
};
export var CALCULATE_ADD_OFFER_ORDER_QUOTE = {
  BEGIN: 'CALCULATE_ADD_OFFER_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_ADD_OFFER_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_ADD_OFFER_ORDER_QUOTE_FAILURE'
};
var CALCULATE_ADD_OFFER_ORDER_QUOTE_EVENTS = [CALCULATE_ADD_OFFER_ORDER_QUOTE.BEGIN, CALCULATE_ADD_OFFER_ORDER_QUOTE.SUCCESS, CALCULATE_ADD_OFFER_ORDER_QUOTE.FAILURE];
export var calculateAddOfferOrderQuotePromise = function calculateAddOfferOrderQuotePromise(dispatch, customer, shoppingCart, billCycleName, customerLanguage, calculateTaxes, paymentInstruments, isDbss) {
  var executionOptions = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
  var isShipping = arguments.length > 9 ? arguments[9] : undefined;
  var shippingInfo = arguments.length > 10 ? arguments[10] : undefined;
  var taxExemption = Object.assign({
    WholesaleFlag: customer.WholesaleFlag || false
  }, customer.TaxExemption);
  return ThunkHelper(dispatch, CALCULATE_ADD_OFFER_ORDER_QUOTE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/CalculateOrderQuote',
    headers: addSubscriberHeaders(customer.Id, customerLanguage),
    data: {
      ExecutionDate: executionOptions.specifiedDate,
      ExecutionDateIntention: executionOptions.effective,
      BillCycleName: billCycleName && billCycleName !== '' ? billCycleName : null,
      CalculateTaxes: !isDbss && calculateTaxes || undefined,
      //Dbss doesn't use this field, it will always CalculateTaxes
      PaymentInstruments: calculateTaxes && paymentInstruments ? paymentInstruments : [],
      RecordPaymentInformation: false,
      ReturnSubscriptionPreviews: true,
      ShoppingCart: shoppingCart,
      TaxExemption: taxExemption,
      IncludeShippingMethods: isShipping,
      ShippingMethodId: shippingInfo ? shippingInfo.methodId : undefined,
      ShippingAddressId: shippingInfo ? shippingInfo.addressId : undefined
    }
  }, {
    // TODO: Customer Order - Should not use a request parameter in the reducer. This should be handled by a separate
    // action that sets if you are calculating with Taxes or not. ASC-96616 will handle fixing quote.
    calculateTaxesInQuote: isDbss || calculateTaxes
  });
};

// Needed for ITV on checkout page
export var calculateAddOfferOrderQuoteWithTaxes = function calculateAddOfferOrderQuoteWithTaxes(customer, shoppingCart, paymentInstrumentsInformation, isDbss, executionOptions, billCycleName, isDeliveryTypeSet) {
  return function (dispatch) {
    return calculateAddOfferOrderQuotePromise(dispatch, customer, shoppingCart, billCycleName, null, true, paymentInstrumentsInformation, isDbss, executionOptions, isDeliveryTypeSet);
  };
};
var handleMultiOfferGoToCheckout = function handleMultiOfferGoToCheckout(dispatch, customer, shoppingCart, language, shouldCalculateTaxes, paymentInstrument, isMultiOfferEditing, isDbss, isMultiOffer) {
  //ToDo: Don't call update updateMultiOfferShoppingCartPromise (UpdateShoppingCart) when there have been no changes made while editing an offer in the multi-offer-add flow
  var offeringInstanceIds = uniq(pluck('OfferingInstanceId', (shoppingCart.Items || []).filter(function (item) {
    return !!item.OfferingInstanceId;
  })));
  if (offeringInstanceIds.length || isMultiOffer) {
    updateMultiOfferShoppingCartPromise(dispatch, customer.Id, shoppingCart, !isMultiOfferEditing).then(function () {
      dispatch(clearOfferingOrderQuote());
      retrieveShoppingCartOfferingsPromise(dispatch, customer.Id).then(function (response) {
        dispatch(clearQuote());
        calculateOfferingOrderQuotePromise(dispatch, customer, response.ShoppingCart).then(function () {
          dispatch(setSelectedOfferingInstanceId(null));
          dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT));
        }).catch(function (error) {
          getUiNotificationService().transientError(error.translatedMessage);
        });
      }).catch(function (error) {
        getUiNotificationService().transientError(error.translatedMessage);
      });
    }).catch(function (error) {
      getUiNotificationService().transientError(error.translatedMessage);
    });
  } else {
    // Single Offer flow that isn't saved
    calculateOfferingOrderQuotePromise(dispatch, customer, shoppingCart).then(function () {
      dispatch(setMultiOfferShoppingCart(shoppingCart));
      dispatch(setSelectedOfferingInstanceId(null));
      dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT));
    }).catch(function (error) {
      getUiNotificationService().transientError(error.translatedMessage);
    });
  }
};
export var fetchAddOfferDecisionsAndNavigate = function fetchAddOfferDecisionsAndNavigate(_ref) {
  var offerId = _ref.offerId,
    customer = _ref.customer,
    _ref$isConvergentBill = _ref.isConvergentBiller,
    isConvergentBiller = _ref$isConvergentBill === void 0 ? true : _ref$isConvergentBill,
    _ref$segmentationCont = _ref.segmentationContext,
    segmentationContext = _ref$segmentationCont === void 0 ? [] : _ref$segmentationCont,
    _ref$shouldCalculateT = _ref.shouldCalculateTaxes,
    shouldCalculateTaxes = _ref$shouldCalculateT === void 0 ? true : _ref$shouldCalculateT,
    _ref$paymentInstrumen = _ref.paymentInstrument,
    paymentInstrument = _ref$paymentInstrumen === void 0 ? [] : _ref$paymentInstrumen,
    isMultiOfferEditing = _ref.isMultiOfferEditing,
    multiOfferShoppingCart = _ref.multiOfferShoppingCart,
    isDbss = _ref.isDbss,
    changeOfferingInstanceId = _ref.changeOfferingInstanceId,
    pickupId = _ref.pickupId;
  return function (dispatch, getState) {
    dispatch(clearQuoteAndSetSelectedOffer(offerId));

    // Set Offers step to invalid until the api call is successful

    // TODO: Customer Order: We should not be grabbing state in the action, the data should be passed in only.
    // TODO: Customer Order: If showing a toast notification, that is something that should be handled in the component
    dispatch(setCurrentStepIsInvalid(true));
    var state = getState();
    var addOffer = EditCustomerInfoSelector(state);
    var subtenantId = !customer.Id ? addOffer.SubtenantId : null;
    return dispatch(retrieveOfferingsMetadata([offerId])).then(function () {
      return retrieveOfferingContextPromise(dispatch, offerId, customer.Id, false, undefined, isConvergentBiller, segmentationContext, addOffer.Language, subtenantId, changeOfferingInstanceId, pickupId).then(function (response) {
        dispatch(setCurrentStepIsInvalid(false));
        if (response.Context.Decisions.length) {
          dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.DECISIONS));
        } else {
          retrieveAttributesPromise({
            dispatch: dispatch,
            offeringId: offerId,
            customerId: customer.Id,
            isConvergentBiller: isConvergentBiller,
            customerLanguage: addOffer.Language,
            subscriberSubtenantId: subtenantId
          }).then(function (response) {
            if (response.Context.ValueDecisions.length || response.Context.PhysicalInventoryDecisions && response.Context.PhysicalInventoryDecisions.length) {
              dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.ATTRIBUTES));
            } else {
              handleMultiOfferGoToCheckout(dispatch, customer, isMultiOfferEditing ? multiOfferShoppingCart : response.ShoppingCart, addOffer.Language, shouldCalculateTaxes, paymentInstrument, isMultiOfferEditing, isDbss);
            }
          });
        }
      });
    }).catch(function (error) {
      getUiNotificationService().transientError(error.translatedMessage);
      dispatch(setSelectedOffer(null));
    });
  };
};
export var fetchAddOfferAttributesAndNavigate = function fetchAddOfferAttributesAndNavigate(_ref2) {
  var offerId = _ref2.offerId,
    offeringInstanceId = _ref2.offeringInstanceId,
    _ref2$completedDecisi = _ref2.completedDecisions,
    completedDecisions = _ref2$completedDecisi === void 0 ? [] : _ref2$completedDecisi,
    customer = _ref2.customer,
    _ref2$completedAttrib = _ref2.completedAttributes,
    completedAttributes = _ref2$completedAttrib === void 0 ? [] : _ref2$completedAttrib,
    _ref2$completedPhysic = _ref2.completedPhysicalAttributes,
    completedPhysicalAttributes = _ref2$completedPhysic === void 0 ? [] : _ref2$completedPhysic,
    _ref2$shouldCalculate = _ref2.shouldCalculateTaxes,
    shouldCalculateTaxes = _ref2$shouldCalculate === void 0 ? true : _ref2$shouldCalculate,
    paymentInstrument = _ref2.paymentInstrument,
    isMultiOfferEditing = _ref2.isMultiOfferEditing,
    isDbss = _ref2.isDbss,
    changeOfferingInstanceId = _ref2.changeOfferingInstanceId,
    pickupId = _ref2.pickupId,
    useSavedShoppingCart = _ref2.useSavedShoppingCart,
    isMultiOffer = _ref2.isMultiOffer;
  return function (dispatch, getState) {
    // TODO: Customer Order: We should not be grabbing state in the action, the data should be passed in only.
    // TODO: Customer Order: If showing a toast notification, that is something that should be handled in the component
    var state = getState();
    var addOffer = EditCustomerInfoSelector(state);
    var routeParams = RouteParams(state);
    var subtenantId = !routeParams.customerId ? addOffer.SubtenantId : null;
    return retrieveAttributesPromise({
      dispatch: dispatch,
      offeringId: offerId,
      offeringInstanceId: offeringInstanceId,
      completedDecisions: completedDecisions.concat(completedAttributes).concat(completedPhysicalAttributes),
      customerId: customer.Id,
      isConvergentBiller: isDbss,
      customerLanguage: addOffer.Language,
      subscriberSubtenantId: subtenantId,
      isReconnectAction: false,
      changeOfferingInstanceId: changeOfferingInstanceId,
      useSavedShoppingCart: useSavedShoppingCart,
      pickupId: pickupId
    }).then(function (response) {
      var visibleValueDecisions = response.Context.ValueDecisions.filter(function (decision) {
        // if there is a DependentServiceAttributeId then the attribute is hidden
        // if they are all hidden, then we don't need to show attributes page
        return !decision.DependentServiceAttributeId;
      });
      if (visibleValueDecisions.length || response.Context.PhysicalInventoryDecisions && response.Context.PhysicalInventoryDecisions.length) {
        return dispatch(goToNextStep());
      } else {
        return handleMultiOfferGoToCheckout(dispatch, customer, isMultiOfferEditing ? EditedMultiOfferShoppingCartSelector(state) : response.ShoppingCart, addOffer.Language, shouldCalculateTaxes, paymentInstrument, isMultiOfferEditing, isDbss, isMultiOffer);
      }
    }).catch(function (error) {
      return getUiNotificationService().transientError(error.translatedMessage ? error.translatedMessage : i18n.translate(CustomerCareKeys.DECISIONS_ERROR));
    });
  };
};
var retrieveShoppingCartOfferingsPromise = function retrieveShoppingCartOfferingsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_SHOPPING_CART_OFFERINGS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveShoppingCartOfferings',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveShoppingCartOfferings = function retrieveShoppingCartOfferings(customerId) {
  return function (dispatch) {
    return retrieveShoppingCartOfferingsPromise(dispatch, customerId);
  };
};
export var SET_IS_RESUMING_ORDER = 'SET_IS_RESUMING_ORDER';
export var setIsResumingOrder = function setIsResumingOrder(resumingOrder) {
  return {
    type: SET_IS_RESUMING_ORDER,
    payload: resumingOrder
  };
};
export var SET_IS_RESUMING_STORE_ORDER = 'SET_IS_RESUMING_STORE_ORDER';
export var setIsResumingStoreOrder = function setIsResumingStoreOrder(resumingOrder) {
  return {
    type: SET_IS_RESUMING_STORE_ORDER,
    payload: resumingOrder
  };
};
export var SET_MULTI_OFFER_SHOPPING_CART = 'SET_MULTI_OFFER_SHOPPING_CART';
export var setMultiOfferShoppingCart = function setMultiOfferShoppingCart(shoppingCart) {
  return {
    type: SET_MULTI_OFFER_SHOPPING_CART,
    payload: shoppingCart
  };
};
export var submitAddOrder = function submitAddOrder(customerInfo, shoppingCart, paymentInfo, billCycleName, executionOptions, recordPaymentInformation, isTransfer, additionalProperties, shippingInfo, orderDetails, offerAdditionalProperties) {
  return function (dispatch) {
    return submitOrderPromise(dispatch, customerInfo, shoppingCart, paymentInfo, billCycleName, executionOptions, recordPaymentInformation, isTransfer, additionalProperties, shippingInfo, orderDetails, offerAdditionalProperties);
  };
};
export var SET_SELECTED_OFFERING_INSTANCE_ID = 'SET_SELECTED_OFFERING_INSTANCE_ID';
export var setSelectedOfferingInstanceId = function setSelectedOfferingInstanceId(selectedOfferingInstanceId) {
  return {
    type: SET_SELECTED_OFFERING_INSTANCE_ID,
    payload: selectedOfferingInstanceId
  };
};
export var SET_DECISIONS_TOUCHED = 'SET_DECISIONS_TOUCHED';
export var setDecisionsTouched = function setDecisionsTouched(payload) {
  return {
    type: SET_DECISIONS_TOUCHED,
    payload: payload
  };
};
export var SET_DOWN_PAYMENT_ON_MULTI_OFFER_SHOPPING_CART = 'SET_DOWN_PAYMENT_ON_MULTI_OFFER_SHOPPING_CART';
export var setDownPaymentOnMultiOfferShoppingCart = function setDownPaymentOnMultiOfferShoppingCart(item) {
  return {
    type: SET_DOWN_PAYMENT_ON_MULTI_OFFER_SHOPPING_CART,
    payload: item
  };
};
export var SET_CHANGE_OFFERING_INSTANCE_ID = 'SET_CHANGE_OFFERING_INSTANCE_ID';
export var setChangeOfferingInstanceId = function setChangeOfferingInstanceId(offeringInstanceId) {
  return {
    type: SET_CHANGE_OFFERING_INSTANCE_ID,
    payload: offeringInstanceId
  };
};
export var SET_CHANGE_OFFERING_ID = 'SET_CHANGE_OFFERING_ID';
export var setChangeOfferingId = function setChangeOfferingId(offeringId) {
  return {
    type: SET_CHANGE_OFFERING_ID,
    payload: offeringId
  };
};